export default __webpack_public_path__ + "static/media/hmd_background_l2.4510317b.jpg";